import React, { useState } from "react";
import { motion } from "framer-motion";
import { Search, Calendar, ArrowRight } from "lucide-react";

const ProgrammeSearchBarRedesign = ({ handleSearch }) => {
  const [q, setQ] = useState();
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();

  const handleSearchClicked = () => {
    let search = {};
    if (q !== null && q !== undefined) {
      search["q"] = q;
    }

    if (startDate !== null && startDate !== undefined) {
      search["startDate"] = startDate;
    }
    if (endDate !== null && endDate !== undefined) {
      search["endDate"] = endDate;
    }

    return handleSearch(search);
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      className="relative bg-white rounded-3xl border-2 border-mamba-sky-blue/20 shadow-lg hover:shadow-2xl hover:border-mamba-golden transition-all duration-300 overflow-hidden"
    >
      {/* Decorative top accent - Mamba Theme */}
      <div className="h-1 bg-gradient-to-r from-mamba-navy via-mamba-sky-blue to-mamba-golden" />

      <div className="p-8">
        {/* Header - Mamba Theme */}
        <div className="mb-6">
          <h3 className="text-2xl font-montserrat font-black text-mamba-navy tracking-tight mb-2">
            Find Your Perfect Program
          </h3>
          <p className="text-slate-600 text-sm font-inter">
            Search by name, dates, or explore all available training programs
          </p>
        </div>

        {/* Search Input */}
        <div className="relative mb-4">
          <div className="absolute left-4 top-1/2 transform -translate-y-1/2 text-slate-400">
            <Search className="w-5 h-5" />
          </div>
          <input
            type="text"
            name="q"
            placeholder="Search programs by name..."
            className="w-full pl-12 pr-4 py-4 border-2 border-mamba-sky-blue/30 rounded-2xl focus:outline-none focus:border-mamba-sky-blue focus:ring-4 focus:ring-mamba-sky-blue/20 transition-all duration-300 text-mamba-navy placeholder:text-slate-400"
            onChange={(text) => setQ(text?.target?.value)}
          />
        </div>

        {/* Date Filters */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
          {/* Start Date */}
          <div className="relative">
            <label className="block text-xs font-bold uppercase tracking-wider text-slate-500 mb-2">
              Start Date
            </label>
            <div className="relative">
              <div className="absolute left-4 top-1/2 transform -translate-y-1/2 text-slate-400">
                <Calendar className="w-5 h-5" />
              </div>
              <input
                type="date"
                name="startDate"
                className="w-full pl-12 pr-4 py-4 border-2 border-mamba-sky-blue/30 rounded-2xl focus:outline-none focus:border-mamba-sky-blue focus:ring-4 focus:ring-mamba-sky-blue/20 transition-all duration-300 text-mamba-navy"
                onChange={(date) => setStartDate(date?.target?.value)}
              />
            </div>
          </div>

          {/* End Date */}
          <div className="relative">
            <label className="block text-xs font-bold uppercase tracking-wider text-slate-500 mb-2">
              End Date
            </label>
            <div className="relative">
              <div className="absolute left-4 top-1/2 transform -translate-y-1/2 text-slate-400">
                <Calendar className="w-5 h-5" />
              </div>
              <input
                type="date"
                name="endDate"
                className="w-full pl-12 pr-4 py-4 border-2 border-mamba-sky-blue/30 rounded-2xl focus:outline-none focus:border-mamba-golden focus:ring-4 focus:ring-mamba-golden/20 transition-all duration-300 text-mamba-navy"
                onChange={(date) => setEndDate(date?.target?.value)}
              />
            </div>
          </div>
        </div>

        {/* Search Button - Mamba Theme */}
        <motion.button
          whileHover={{ scale: 1.02, y: -2 }}
          whileTap={{ scale: 0.98 }}
          className="w-full group relative px-6 py-4 bg-gradient-to-r from-mamba-navy to-mamba-sky-blue text-white font-montserrat font-bold rounded-2xl shadow-lg hover:shadow-mamba-sky-blue/50 transition-all duration-300 overflow-hidden"
          onClick={handleSearchClicked}
        >
          {/* Shine effect */}
          <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-1000" />

          <span className="relative flex items-center justify-center gap-2">
            <Search className="w-5 h-5" />
            Search Programs
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
          </span>
        </motion.button>
      </div>
    </motion.div>
  );
};

export default ProgrammeSearchBarRedesign;
